import React from 'react';

export interface KeyboardShortcut {
  key: string;
  label: string;
}

interface KeyboardShortcutsProps {
  shortcuts?: KeyboardShortcut[];
}

export const KeyboardShortcuts: React.FC<KeyboardShortcutsProps> = ({ shortcuts }) => {
  if (!shortcuts || shortcuts.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center space-x-2 text-xs text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-700 px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-600">
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
      {shortcuts.map(shortcut => (
        <React.Fragment key={shortcut.key}>
          <kbd className="px-1.5 py-0.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-500 rounded font-mono">
            {shortcut.key}
          </kbd>
          <span>{shortcut.label}</span>
        </React.Fragment>
      ))}
    </div>
  );
};

